"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WiFiNetworks = exports.WiFiNetwork = void 0;
const effect_1 = require("effect");
const net_1 = require("../../../net");
const compound_1 = require("../../../unit/compound");
const common_1 = require("../common");
const NAMESPACE = 'Network.WiFi.Survey.Common';
exports.WiFiNetwork = effect_1.Schema.Struct({
    bssid: net_1.MacAddress,
    channel: common_1.Channel,
    rssi: compound_1.DecibelMilliwatts.fields.amount,
}).annotations({ identifier: `${NAMESPACE}.WiFiNetwork` });
exports.WiFiNetworks = effect_1.Schema.Array(exports.WiFiNetwork).annotations({
    identifier: `${NAMESPACE}.WiFiNetworks`,
});
//# sourceMappingURL=common.js.map